const dashboard = {
    greeting: {
      morning: 'Good morning',
      morningNamed: 'Good morning, {{name}}',
      afternoon: 'Good afternoon',
      afternoonNamed: 'Good afternoon, {{name}}',
      evening: 'Good evening',
      eveningNamed: 'Good evening, {{name}}',
    },
    title: 'Dashboard',
    sheetLabel: 'Technical knowledge base',
    lastUpdated: 'Last updated',
    subtitle: 'What has changed in your knowledge base, and where to go next',
    priorityHigh: 'Important',
    quickActionsTitle: 'Quick actions',
    noRecentDocuments: 'No recent documents',
    quickActions: {
      upload: 'Add a new file and let REVY index it',
      search: 'Search across the whole knowledge base',
      drbfm: 'Analyse failure modes from a design change',
      verification: 'Create and track design verification items',
    },
    totalDocuments: 'Total Documents',
    recentUploads: 'Recent Uploads',
    totalViews: 'Total Views',
    activeUsers: 'Active Users',
    fromLastMonth: 'from last month',
    inLast7Days: 'in last 7 days',
    allTime: 'across the knowledge base',
    latestRecord: 'most recent record',
    thisMonth: 'this month',
    currentlyOnline: 'currently online',
    recentDocuments: 'Recent Documents',
    viewAll: 'View All',
    trendingSearches: 'Trending Searches',
    lastNDays: 'Last {{days}} days',
    announcements: 'Announcements',
    noAnnouncements: 'No announcements at this time',
    searches: '{{count}} searches',
    announcementAuthor: 'Development team',
    announcementItems: {
      drbfmKnowledge: {
        title: 'Improved DRBFM related-knowledge citations',
        message: 'Review linked files, excerpts, and relevance in DRBFM failure-mode details.',
      },
      chatQuality: {
        title: 'Improved chat search and reference quality',
        message: 'Search result grouping, reference relevance, and grounded answers are more stable.',
      },
      auditOperations: {
        title: 'Expanded audit logs and operations observability',
        message: 'Key operation audit logs, anomaly detection, and admin CSV exports are now supported.',
      },
      helpRefresh: {
        title: 'Updated help and operation guides',
        message: 'Search, chat, DRBFM, CAD, and audit guidance now match the current feature set.',
      },
    },
  };

export default dashboard;
